import { render, staticRenderFns } from "./GyIcon.vue?vue&type=template&id=74548c59&"
import script from "./GyIcon.vue?vue&type=script&lang=js&"
export * from "./GyIcon.vue?vue&type=script&lang=js&"
import style0 from "./GyIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports